<app-create-extras [extrasInfoData]="receivedData"></app-create-extras>
